import React from 'react'
import './index.css'

function Modal({ closeModal}) {

    return (
        <div className='access-modal-background'>
            <div className='access-modal-container'>
                <div className='access-modal-title flex-column'>
                    <p>تست‌های شما به اتمام رسیده است!</p>
                    <p>جهت استفاده از این محصول، نیاز است مجددا خریداری نمایید ...</p>
                </div>
                <button onClick={() => closeModal(false)}>
                        متوجه شدم
                </button>
            </div>
        </div>
    )
}

export default Modal